import { Box, Button, Grid2, IconButton, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
import React, { useEffect, useMemo, useState } from "react";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import CloseIcon from '@mui/icons-material/Close';
import TokenError from "../tokenError";
import config from '../../config/config.js';
import CommonGeofence from "../geofence/CommonGeofence.jsx";
import { Label } from "flowbite-react";
import { GoogleMap, Polygon, useJsApiLoader } from "@react-google-maps/api";
import constants from '../../constant.js';
import { useNavigate } from "react-router-dom";

const LIBRARIES = ["maps", "drawing", "places", "geometry"];

const CustomZone = () => {
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [city, setCity] = useState(cities[0]);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [CustomZoneData, setCustomZoneData] = useState([]);
    const customZoneTypeConst = constants.CustomZoneTypeConst;
    const [zoneName, setZoneName] = useState('');
    const [zoneType, setZoneType] = useState('');
    const [rate, setRate] = useState('');
    const cityGeo = city ? city.geofence[0] : '';
    const [customGeofence, setCustomGeofence] = useState(cityGeo);
    const [customZoneId, setCustomZoneId] = useState(-1);
    const [activeStatus, setActivestatus] = useState(1);
    const [callDeleteAPI, setCallDeleteAPI] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [polyPath, setPolyPath] = useState([]);
    const [mapInstance, setMapInstance] = useState(null);
    const [bound, setBound] = useState(false);

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (mapInstance && customGeofence && customGeofence.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            customGeofence.forEach((point) =>
                bounds.extend({ lat: point.x, lng: point.y })
            );
            mapInstance.fitBounds(bounds);
        }
    }, [customGeofence, bound]);

    console.log('main data = ', cityFilter, 'city=', city, 'customGeofence=', customGeofence);

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
        setCity(city);
        const geoo = city ? city.geofence[0] : '';
        setCustomGeofence(geoo);
        console.log('city....', cities[0]);
    }

    const handleUpdatePolygon = (polygonPath) => {
        console.log("Updated polygon path received from child:", polygonPath);
        // setCustomGeofence(polygonPath);
        setPolyPath(polygonPath);
    };

    const fetchCustomZoneData = async() => {
        try {
            const url = serverUrl + '/custom/fetch_custom_zones';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setCustomZoneData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }
    useEffect(() => {
        fetchCustomZoneData();
    }, [cityFilter]);

    const handleGridClick = (data) => {
        const city =  cities.find((cityObj) => cityObj.city_id === data.city_id)
        const geo = data.geofence ? data.geofence[0] : (city ? city.geofence[0] : '');
        setCustomGeofence(geo);
        // console.log('daayaya = ', data);
        // setCustomGeofence(data.geofence[0]);
    }

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
        setOpenEditModal(false);
        setCustomZoneId(1);
        setZoneName('');
        setZoneType('');
        setRate('');
        setCustomGeofence([]);
        setActivestatus(1);
        setCustomZoneId(-1);
    }

    const handleOpenEdit = (row) =>{
        setCustomZoneId(row.zone_id);
        setZoneName(row.name);
        setZoneType(row.type);
        if(row.rate) setRate(row.rate);
        setOpenEditModal(true);
        setOpenAddModal(false);
        // 
        // const paths = 
        setCustomGeofence(row.geofence ? row.geofence[0] : []);
        setActivestatus(1);
    }
    const handleDeleteFunc = (row) => {
        setCustomZoneId(row.zone_id);
        setActivestatus(0);
        setZoneName(row.name);
        if(row.rate) setRate(row.rate);
        setZoneType(row.type);
        setCustomGeofence(row.geofence[0]);
        setCallDeleteAPI(true);
    }

    const handleClose=()=>{
        setOpenEditModal(false);
        setOpenAddModal(false);
        const geof = cities.find(city => city.city_id === cityFilter)
        // console.log('geof====', geof.geofence[0]);
        setCustomGeofence(geof.geofence[0])
    }

    useEffect(() => {
        if(callDeleteAPI === true) {
            saveData();
            setCallDeleteAPI(false);
        }
    }, [callDeleteAPI])

    const saveData = async() =>{
        const geo = customGeofence.map((point) => ({
            lat: point.x ?  Number(point.x) : point.lat, // Convert x to lat
            lng: point.y ?  Number(point.y) : point.lng // Convert y to lng
        }))
        const payload = {
            token: token,
            name: zoneName,
            type: zoneType,
            status: activeStatus,
            geofence: polyPath? polyPath: geo,
            city_id: cityFilter,
        }
        if(rate) payload['rate']=rate;
        if(customZoneId!=-1){
            payload.zone_id = customZoneId;
        }
        
        try {
            const url = operationsUrl + '/custom/add_update_custom_zones';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                handleClose();

            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            // setMessage(error);
        }

        fetchCustomZoneData();
    }

    const loaderOptions = {
        id: 'google-map-script',
        googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
        libraries: LIBRARIES,
    }
    
    const { isLoaded, loadError } = useJsApiLoader(loaderOptions);

    const containerStyle = {
        width: '100%',
        height: '480px',
      };
    const center = {
        // lat: 28.644800, lng: 77.216721
        lat: customGeofence ? customGeofence.reduce((sum, point) => sum + point.x, 0) / customGeofence.length : 0,
        lng: customGeofence ? customGeofence.reduce((sum, point) => sum + point.y, 0) / customGeofence.length : 0,
    };

    const onLoad = React.useCallback(function callback(map) {
        setMapInstance(map);
    }, []);
    
    const onUnmount = React.useCallback(function callback(map) {
        setMapInstance(null);
        console.log('unmounting');
    }, []);

   

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };
    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Custom Zone</Typography>

            <Grid2 item container spacing={2} sx={{marginTop:'2%'}}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddModal}
                        style={{width:'190px', height:'50px', backgroundColor:'#000000', textTransform:'none', borderRadius:'8px'}}>
                        + Add Custom Zone
                    </Button>
                </Grid2>
            </Grid2>

            <Grid2 item container size={12} spacing={2} sx={{marginTop:'2%'}}>
                <Grid2 item size={4} sx={{ overflowY:'auto', maxHeight:'580px'}}>
                    {(CustomZoneData).map((data) => {
                        const type = constants.CustomZoneTypeConst[data.type] || null;
                        return(
                            <Grid2 item sx={{backgroundColor:'#fff', borderRadius:'12px', padding:'4px', marginBottom:'4%', cursor:'pointer'}}
                                key={data.zone_id} onClick={() => handleGridClick(data)}
                                >
                                <Grid2 item container spacing={1.6} sx={{marginBottom:'8px', padding:'12px'}}>
                                    {/* <Typography>{data.name}</Typography> */}
                                    <Typography sx={{color:'#000'}}>Name: <span style={{color:'#83888E'}}>{data.name}</span></Typography>
                                    <Typography sx={{marginLeft:'auto', color:'#000', fontSize:'14px'}}>ID: {data.zone_id}</Typography>
                                </Grid2>

                                <Grid2 sx={{marginBottom:'8px', padding:'12px'}}>
                                    <Typography sx={{color:'#000'}}>Charge: <span style={{color:'#83888E'}}>{data.rate}</span></Typography>
                                    {/* <Typography sx={{marginLeft:'auto', color:'#83888E', fontSize:'14px'}}></Typography> */}
                                </Grid2>

                                <Grid2 sx={{backgroundColor:'#F9F9F9', padding:'8px', margin:'6px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius:'4px'}}>
                                    <Typography sx={{fontSize:'14px', color:'#000', marginRight:'12px'}}>Zone Type : </Typography>
                                    <Typography sx={{fontSize:'14px', justifyContent:'center', color:'#83888E'}}>{type}</Typography>
                                </Grid2>

                                {/* <hr/> */}
                                <hr style={{ marginTop: '16px', marginBottom: '16px', border: 'none', borderTop: '1px solid #ccc' }} />

                                <Grid2 item container spacing={1.6} sx={{marginBottom:'8px'}}>
                                    <Button sx={{border:'1px solid #C71F1F', width:'140px', marginLeft:'8px'}} onClick={() => handleDeleteFunc(data)}>
                                        <Typography sx={{color:'#C71F1F', textTransform:'none'}}>Delete</Typography>
                                    </Button>
                                    <Button variant="contained" sx={{width:'140px', backgroundColor:'#0DBA78'}} 
                                    onClick={() => handleOpenEdit(data)}
                                    >
                                        <Typography sx={{color:'#EFFBF7', textTransform:'none'}}>Edit</Typography>
                                    </Button>
                                </Grid2>
                            </Grid2>
                        )
                    })}
                    
                </Grid2>

                <Grid2 item size={8}>
                    <Grid2 className='mainBox' sx={{marginTop:'2%'}}>
                        {isLoaded ? (
                            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={8} onIdle={()=> { setBound(true)}} onLoad={onLoad} onUnmount={onUnmount}>
                                
                                {city && city.geofence && city.geofence[0].length > 0 && (
                                    <Polygon
                                        paths={customGeofence.map((point) => ({
                                            lat: Number(point.x), // Convert x to lat
                                            lng: Number(point.y)  // Convert y to lng
                                        }))
                                        .filter((point) => !isNaN(point.lat) && !isNaN(point.lng) && isFinite(point.lat) && isFinite(point.lng))
                                    } 
                                        options={{
                                            fillColor: "rgba(255, 0, 0, 0.3)", // Semi-transparent fill color
                                            fillOpacity: 0.4,
                                            strokeColor: "red",
                                            strokeOpacity: 1,
                                            strokeWeight: 2,
                                        }}
                                    />
                                )}
                                
                            </GoogleMap>
                            
                        ): (<></>)}
                    </Grid2>
                </Grid2>
            </Grid2>

            {(openAddModal || openEditModal) && (
                <div 
                style={{position: 'fixed',top: 65, right:0, height: '100%',width: '78%',backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,overflowY: 'auto',padding: 20
                }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>

                            <Grid2 item container spacing={2} size={12} sx={{marginLeft:'12px'}}>
                                <Grid2 item size={5} sx={{backgroundColor:'#fff', padding:'12px', borderRadius:'12px', overflowY:'auto',maxHeight: '430px'}}>
                                    <Typography sx={{color:'#4E545D', fontSize:'24px', fontWeight:500}}>New Custom Zone</Typography>
                                    
                                    <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                        <Label>Zone Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField  sx={{marginTop:'2%'}}
                                            placeholder="Zone Name" fullWidth variant="outlined" type="text" 
                                            value={zoneName}
                                            onChange={(e) => setZoneName(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                        <Label>Zone Type<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'2%'}}
                                            placeholder="Select Zone Type" select
                                            fullWidth variant="outlined"
                                            value={zoneType}
                                            onChange={(e) => setZoneType(e.target.value)}
                                            InputProps={{
                                                style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF',},
                                            }}
                                        >
                                            {Object.entries(constants.CustomZoneTypeConst).map(([id, label]) => (
                                                <MenuItem key={id} value={id}>
                                                    {label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid2>

                                    { (constants.customZoneCharge).indexOf(+(zoneType)) !== -1 && (
                                        <Grid2 item sx={{marginTop:'4%', padding:'4px'}}>
                                            <Label>Charge<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField  sx={{marginTop:'2%'}}
                                                placeholder="Charge" fullWidth variant="outlined" type="text" 
                                                value={rate}
                                                onChange={(e) => setRate(e.target.value)}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '46px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                                }}
                                            />
                                        </Grid2>
                                    )}

                                    <Grid2 container item sx={{marginTop:'6%', justifyContent:'center', marginBottom:'4%'}} spacing={4}>
                                        <Grid2 item>
                                            <Button variant="contained" sx={{backgroundColor:'#0065FF'}} onClick={saveData}>{openAddModal ? 'Create' : 'Update'}</Button>
                                        </Grid2>
                                        <Grid2 item>
                                            <Button variant="contained" sx={{backgroundColor:'#D14545'}} onClick={handleClose}>Cancel</Button>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <Grid2 item size={7}>

                                    <CommonGeofence geofence={customGeofence ? customGeofence : null} onUpdatePolygon={handleUpdatePolygon} />
                                    
                                </Grid2>
                            </Grid2>
                        </div>
                    </Box>
                </div>
            )}

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
                
        </div>
    )
}

export default CustomZone;